var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"main"},[_c('left-nav',{attrs:{"topNav":_vm.topNav,"secNav":_vm.secNav,"thirdNav":_vm.thirdNav}}),_vm._v(" "),_c('main-right')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316f5ee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/components/swiper/Swiper.vue
// module id = null
// module chunks = 